/**
 * Les notifications « messages » du téléphone, telles que l'ancien chat les effaçait
 * (`CommonChat.clearNotifications("messages")`). Le web n'en a pas : rien n'y part.
 */
import * as Notifications from "expo-notifications"
import { Platform } from "react-native"

/** Le chemin des notifications de messages (`data.path`). */
export const MESSAGE_NOTIFICATION_PATH = "messages"

/** Les notifications de messages déjà affichées, effacées. */
export function clearMessageNotifications() {
    if (Platform.OS === "web") return
    Notifications.getPresentedNotificationsAsync()
        .then((notifications) => {
            for (const notification of notifications) {
                if (notification.request.content.data?.path === MESSAGE_NOTIFICATION_PATH) {
                    void Notifications.dismissNotificationAsync(notification.request.identifier)
                }
            }
        })
        .catch(() => {})
}
